import type { LobbyState, PendingGameStart } from './lobbyStore.types';

export const uiSlice: Pick<
  LobbyState,
  | 'isLoading'
  | 'error'
  | 'isInitialized'
  | 'lobbyUpdatedReceived'
  | 'sessionStateReceived'
  | 'pendingGameStart'
  | 'quickStartPending'
  | 'heroOverlayCharId'
  | 'justCreatedCharacter'
  | 'setLoading'
  | 'setError'
  | 'setInitialized'
  | 'setLobbyUpdatedReceived'
  | 'setSessionStateReceived'
  | 'setPendingGameStart'
  | 'setQuickStartPending'
  | 'setHeroOverlayCharId'
  | 'setJustCreatedCharacter'
> = {
  isLoading: false,
  error: null,
  isInitialized: false,
  lobbyUpdatedReceived: false,
  sessionStateReceived: false,
  pendingGameStart: null,
  quickStartPending: false,
  heroOverlayCharId: null,
  justCreatedCharacter: false,

  setLoading: (isLoading: boolean) => ({ isLoading }),
  setError: (error: string | null) => ({ error }),
  setInitialized: (isInitialized: boolean) => ({ isInitialized }),
  setLobbyUpdatedReceived: (lobbyUpdatedReceived: boolean) => ({ lobbyUpdatedReceived }),
  setSessionStateReceived: (sessionStateReceived: boolean) => ({ sessionStateReceived }),
  setPendingGameStart: (pendingGameStart: PendingGameStart | null) => ({ pendingGameStart }),
  setQuickStartPending: (quickStartPending: boolean) => ({ quickStartPending }),
  setHeroOverlayCharId: (heroOverlayCharId: string | null) => ({ heroOverlayCharId }),
  setJustCreatedCharacter: (justCreatedCharacter: boolean) => ({ justCreatedCharacter }),
};
